import React from 'react';
import '../../styles/pages/Instructions.scss';

const Instructions: React.FC = () => {
    return (
        <div className="container">
            <h1>Item Lookup and Creation Application</h1>
            <p>Welcome to the Automated Attribute Application at Zachys. This application provides a quick and simple way to lookup items, find attributes and prices, and create new NetSuite items. You can follow the instructions below to begin using the system.</p>
            <h2>Item Lookup</h2>
            <ol>
                <li>Open a browser window and navigate to <a href={"https://"+window.location.hostname} target="_blank">{window.location.hostname}</a></li>
                <li>When prompted to login, click the <strong>"Zachys Microsoft Entra ID"</strong> button at the bottom. <strong>Note:</strong> The email address associated with your Zachys account will be the address the application sends the completed worksheet.</li>
                <img src="../instructions/login.png" alt="Login Screenshot" />
                <li>Upon successful login, you will be redirected to the landing page. The landing page is where you will upload your initial worksheet or bottle images for automated attribution.</li>
                <img src="../instructions/selectfile.png" alt="Choose Form Screenshot" />
                <li>Click <strong>Select Files</strong> to choose either a) One or more image files to upload or b) A completed template sheet. Upon selecting, the screen will display a list of the files that will be uploaded. <strong>You can either upload a single worksheet or one or more image files. You cannot mix the two in a single upload.</strong></li>
                <li>After verifying the list of files to be uploaded, click <strong>"Upload"</strong> to complete the upload and begin the attribution process. If uploading a worksheet, please only upload a workbook with the template sheet. If using this workbook, please delete all other tabs prior to uploading.</li>
                <li>The system will email the resulting spreadsheet to your Zachys email address associated with your login account. It may take up to 10 minutes to receive your results.</li>
            </ol>

            <h2>Item Creation</h2>
            <p>This spreadsheet allows you to create NetSuite products by uploading the required attributes via an Excel sheet. When you upload the spreadsheet, the application checks for the following:</p>
            <ol>
                <li><strong>SKU Check:</strong> If there is a value in the <code>SKU</code> column of the spreadsheet, the row is ignored and no item will be created.</li>
                <li><strong>Duplicate Product Check:</strong> If there is already a product in the system that matches the <code>PRODUCER</code>, <code>PRODUCT NAME</code>, <code>SIZE</code>, and <code>VINTAGE</code> columns, a new item will not be created.</li>
            </ol>

            <p>If both of these checks are passed, the system will create a new item in NetSuite using the entries from the spreadsheet.</p>

            <p>When preparing your spreadsheet, only the following columns will be used by the system:</p>
            <ul>
                <li>Producer</li>
                <li>Product Name</li>
                <li>Size</li>
                <li>Vintage</li>
                <li>Department</li>
                <li>Class</li>
                <li>Varietal</li>
                <li>Country</li>
                <li>Region</li>
                <li>Appelation</li>
            </ul>

            <p><strong>Note:</strong> The order of the columns does not matter, but the column names must match exactly as listed above.</p>

            <h3>To process a spreadsheet, follow these 2 simple steps:</h3>
            <ol>
                <li>Click <strong>"Choose Files"</strong> and select the spreadsheet containing the products you want to create.</li>
                <li>Enter your email address in the <strong>"Email Results"</strong> field. This is where the response from the application will be sent once processing is complete.</li>
            </ol>
            <p>Item Upload Screen</p>

            <img src="../instructions/uploadform.png" alt="Upload Form Screenshot" />
            <h2>Returning Results</h2>
            <p>Once the spreadsheet has processed, you will receive an email confirmation to the submitted email address with the results. An example return email is included below.</p>
            <img src="../instructions/returnemail.png" alt="Sample Output Email" />
        </div>
    );
};

export default Instructions;